import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { SuccessDialogComponent } from './components/success-dialog/success-dialog.component';

/**
 * Root-safe dialogs for AppComponent / SessionHttpErrorHandler.
 * Keep out of full SharedModule so AppModule can stay thin but still open MatDialog.
 */
@NgModule({
  declarations: [SuccessDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
  ],
  exports: [
    SuccessDialogComponent,
    MatDialogModule,
  ],
})
export class ShellDialogsModule {}
